export const FOLLOW_SETTINGS_ERROR_MESSAGE =
  "We couldn’t update your follow settings. Please try again. If the problem continues, contact support.";
